import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function AdhdPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0 space-y-4">
        <h1 className="custom-heading">
          {t("pages.onboardingV1.adhd.heading")}
        </h1>

        <h2 className="custom-subheading">
          {t("pages.onboardingV1.adhd.subheading")}
        </h2>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="📝"
          label={t("pages.onboardingV1.adhd.diagnosed")}
          name={t("pages.onboardingV1.adhd.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.adhd.diagnosed", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="🤔"
          label={t("pages.onboardingV1.adhd.suspect")}
          name={t("pages.onboardingV1.adhd.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.adhd.suspect", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-blue"
          emoji="🙂"
          label={t("pages.onboardingV1.adhd.noAdhd")}
          name={t("pages.onboardingV1.adhd.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboardingV1.adhd.noAdhd", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
